<template>
    <bs5-base-modal title="Add Client" :visible="visible" @close="closeModal">
        <template v-slot:default>
            <form @submit.prevent="addClient">
                <div class="mb-3">
                    <bs5-base-label for="name">Name</bs5-base-label>
                    <bs5-base-input id="name" v-model="newClient.name" required />
                </div>

                <div class="mb-3">
                    <bs5-base-label for="description">Description</bs5-base-label>
                    <bs5-base-input id="description" v-model="newClient.description" />
                </div>
            </form>
        </template>

        <template v-slot:footer>
            <bs5-cancel-button @click="closeModal" />
            <bs5-save-button :loading="saving" @click="addClient">Add Client</bs5-save-button>
        </template>
    </bs5-base-modal>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import clientService from "@/services/client.service";
import { Client } from "@/models/client.model";
import { showToast } from "@/utils/toast";

export default defineComponent({
    name: "AddClientModal",
    props: {
        visible: { type: Boolean, required: true },
        distributorId: { type: String, required: true }, // ✅ Dystrybutor, do którego dodajemy klienta
    },
    emits: ["close", "client-added"],
    data() {
        return {
            newClient: ref<Omit<Client, "id">>({ name: "", description: "", distributorId: this.distributorId }),
            saving: ref(false),
        };
    },
    watch: {
        distributorId: {
            immediate: true,
            handler(newId) {
                this.newClient.distributorId = newId;
            },
        },
    },
    methods: {
        async addClient() {
            this.saving = true;
            try {
                await clientService.createClient({ ...this.newClient, distributorId: this.distributorId });
                this.$emit("client-added");
                this.closeModal();
                showToast("Client added!",  "success");
            } catch (error) {
                showToast("Failed to add client!",  "error");
                console.log(error);
            } finally {
                this.saving = false;
            }
        },
        closeModal() {
            this.$emit("close");
        },
    },
});
</script>